import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const UrbaniaMono = ({ color, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="73.7px"
        height="25.5px"
        viewBox="0 0 73.7 25.5"
        className={className}
    >
        <path
            fill={color}
            d="M27 12.2c0-.1 1-.3 1.7-1.2.5-.7.7-1.3.7-2.5v-3c0-1.5-.4-2.9-1.4-4C26.9.5 25.2 0 23.7 0h-3.6c-.4 0-.7 0-.9.2-.2.2-.2.5-.2 1v23c0 .8 0 .8.2 1.1.1.2.6.1 1.1.2h3.5c1.4 0 3.1-.4 4.2-1.6 1.2-1.3 1.5-2.5 1.5-3.9v-4.2c0-1-.1-1.6-.6-2.2-.7-1.2-1.9-1.3-1.9-1.4m-4.1-7.7c0-.2 0-.4.1-.5s.4-.1.8-.1c.7 0 .9.1 1.2.4.5.5.5 1.2.5 2v2.5c0 .4 0 .9-.5 1.4-.4.4-.9.5-1.3.5-.3 0-.5 0-.7-.1-.2-.1-.2-.4-.2-.7V4.5zm2.7 15c0 .7 0 1.1-.5 1.6-.4.4-1 .5-1.3.5h-.7c-.3 0-.3-.4-.3-.8v-6c0-.7.1-.7 1.3-.7 1.1 0 1.5.9 1.5 2.3v3.1zM14.7 12.3c0-.1 1.1-.3 1.8-1.3.5-.7.6-1.3.6-2.4V5.5c0-1.5-.4-3-1.5-4S12.9 0 11.3 0H7.7c-.5 0-.7 0-.9.2-.1.2-.2.6-.2 1v18.3c0 1-.2 2-1.4 2s-1.4-1.1-1.4-2V.6C3.9.1 3.5 0 2 0 .2 0 0 0 0 .6v19.7c0 2.6 2 5 5.3 5 3.4 0 5.3-2.1 5.3-5.1v-6c.1-.2.4-.2 1.4-.2.9 0 1.3 1 1.3 2.3v8.3c0 .7.1.6 1.9.6 1.7 0 2 0 2-.6v-9.1c0-1-.2-1.6-.7-2.3-.7-.7-1.8-.8-1.8-.9m-1.5-3.6c0 .4 0 .9-.5 1.4-.4.4-1 .5-1.3.5-.3 0-.5 0-.7-.1-.2-.1-.2-.4-.2-.7V4.5c0-.2 0-.3.1-.5s.4-.2.7-.2c.8 0 1.1.1 1.3.4.5.5.5 1.2.5 2v2.5zM39.2 25.5c-1.1 0-1.7.1-1.8-.4-.3-2-.4-3.4-.7-5.4 0-.4-.5-.3-1.1-.3-.7 0-1.1-.1-1.1.3-.2 2-.4 3.4-.5 5.5 0 .4-.8.4-2 .4-.5 0-1.8 0-1.8-.3 1.3-9.5 2.3-15.8 3.5-24.6.1-.7 1.1-.7 1.9-.7.9 0 1.9 0 2 .7 1.4 9.3 2.2 15 3.6 24.4.1.4-1 .4-2 .4M35.9 9.3c0-.2-.1-1-.3-1-.2 0-.3.9-.2 1.1-.2 2.8-.3 4.6-.5 7 0 .3.2.3.7.3.5 0 .8.1.8-.3-.2-2.7-.3-4.3-.5-7.1M52.4 25.5c-.9 0-1.3-.1-1.6-1-1.2-4.2-1.6-6.1-2.9-10.7-.2-.8-.5-2.1-.8-2.1-.3 0-.3.8-.3 1.2v11.9c0 .6-.1.7-2 .7-1.8 0-1.8-.1-1.8-.6V.5c.1-.5.1-.5 1.7-.5 1.6 0 1.8.1 2 1.2.8 3 1.9 6.9 2.9 10.7.1.4.2.9.4.9.3 0 .3-.7.3-1.1V.7c0-.6.1-.7 1.9-.7 1.9 0 1.9 0 1.9.6v23.7c.1 1 .2 1.2-1.7 1.2M58.8 25.4c-1.8 0-1.9 0-1.9-.5V.7c0-.5.1-.6 1.9-.6 1.9 0 2 0 2 .6v24.1c.1.6 0 .6-2 .6M71.7 25.5c-1.1 0-1.7.1-1.8-.4-.3-2-.4-3.4-.7-5.4 0-.4-.5-.3-1.1-.3-.7 0-1.1-.1-1.1.3-.2 2-.4 3.4-.5 5.5 0 .4-.8.4-2 .4-.5 0-1.8 0-1.8-.3C64 15.8 65 9.5 66.2.7c.1-.7 1.1-.7 1.9-.7.9 0 1.9 0 2 .7 1.4 9.3 2.2 15 3.6 24.4.1.4-1 .4-2 .4M68.4 9.3c0-.2-.1-1-.3-1-.2 0-.3.9-.2 1.1-.2 2.8-.3 4.6-.5 7 0 .3.2.3.7.3.5 0 .8.1.8-.3-.2-2.7-.3-4.3-.5-7.1"
        />
    </svg>
);

UrbaniaMono.propTypes = propTypes;
UrbaniaMono.defaultProps = defaultProps;

export default UrbaniaMono;
